import { render, staticRenderFns } from "./DutyListItem.vue?vue&type=template&id=f212948a&scoped=true&"
import script from "./DutyListItem.vue?vue&type=script&lang=js&"
export * from "./DutyListItem.vue?vue&type=script&lang=js&"
import style0 from "./DutyListItem.vue?vue&type=style&index=0&id=f212948a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f212948a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
